// extracted by mini-css-extract-plugin
module.exports = {"storyblok-services-list":"StoryblokServicesList_storyblok-services-list__r3QDN"};